import { Accordion, AccordionProps } from '@mui/material'
import React from 'react'

type StyledAccordionProps = AccordionProps & {
  children: React.ReactNode
}

const StyledAccordionContainer: React.FC<StyledAccordionProps> = ({ children, ...accordionProps }) => {
  return (
    <Accordion
      {...accordionProps}
      sx={(theme) => {
        const userSx =
          typeof accordionProps.sx === 'function' ? accordionProps.sx(theme) : accordionProps.sx
        return {
          '&.MuiAccordion-root:before': {
            display: 'none',
          },
          ...(userSx as object),
        }
      }}
    >
      {children ?? <></>}
    </Accordion>
  )
}

export default StyledAccordionContainer
